<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc1"><a href="#/chapter01">The Origins of a Resort</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">From 1850 to 1863</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">The Civil War</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">The Lottery of Death</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">The Railroad Comes to Cape May</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">The Cottage Era</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Railroad Control</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">The Fire of 1869</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Depression and Reconstruction</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">The Inferno</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">The Road Not Taken</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Growth After the Fire</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">The <i>Republic</i> Era</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">New Jersey Newport</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">Cool Cape May</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">The Great Atlantic Hurricane</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">Peace and Preservation</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">The Winds of Change</span></p>
<p class="toc"><span href="#/chapter19" title="Link target outside of Sample">“Putting More Christianity in the Patriots”</span></p>
<p class="toc"><span href="#/chapter20" title="Link target outside of Sample">The City Is the Project: Everything Old Is New Again</span></p>
<p class="toc"><span href="#/chapter21" title="Link target outside of Sample">Renaissance</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4a0b03e6